/* eslint-disable */
import React from "react";
import { Card, Title, Text, Divider, List } from "@mantine/core";

export default function InformationCollectedCard() {
  return (
    <Card shadow="sm" radius="md" withBorder>
      <Title order={3}>Information Collected while Using the Application</Title>
      <Divider my="md" />
      <Text>
        While using our Application, in order to provide features of our
        Application, we may collect, with your prior permission:
      </Text>

      <List spacing="xs" mt="sm">
        <List.Item>Information regarding your location</List.Item>
        <List.Item>
          Pictures and other information from your device’s camera and photo
          library
        </List.Item>
      </List>

      <Text mt="md">
        We use this information to provide features of our Service, to improve
        and customize our Service. The information may be uploaded to the
        Company’s servers and/or a Service Provider’s server, or it may be
        simply stored on your device.
      </Text>

      <Text mt="sm">
        You can enable or disable access to this information at any time through
        your device settings.
      </Text>
    </Card>
  );
}
